import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import {
  MessageRetailerOrBrandButton,
  additionalDataRequiredForContactingRetailerOrBrandCTA,
} from "../../shared/instantAnswerUtils";

import { ManageShippingAddressesCTA } from "./ctas";

export const UpdateAccountShippingAddressIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.(
          context.brandOrder
        );
      },
    },
    secondaryCtaBuilder: {
      textBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.label;
      },
      onClickFunctionBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.onClick;
      },
    },

    additionalRequiredData:
      additionalDataRequiredForContactingRetailerOrBrandCTA(),
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => CHANGE_YOUR_SHIPPING_ADDRESS(strictLocalize),
    getDescription: () => [
      USE_BUTTON_TO_UPDATE_ACCOUNT_SHIPPING_ADDRESS(strictLocalize),
    ],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return ManageShippingAddressesCTA(strictLocalize);
};

const CHANGE_YOUR_SHIPPING_ADDRESS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Change your shipping address",
    description: {
      text: "Title for the answer of update shipping address on the account issue",
    },
  });

const USE_BUTTON_TO_UPDATE_ACCOUNT_SHIPPING_ADDRESS = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Update the shipping address on your account using the button below. If you’d like to change the address on an order, contact the brand directly.",
  });
